import type {
  PerformancePage,
  PerformancePageTimeSeries,
  TimeSeriesPoint,
} from 'api/new-analytics/types';

export function sumTimeSeriesForPagesMetric(
  pages: PerformancePage[],
  metricKey: string,
): TimeSeriesPoint[] {
  const seriesList = pages.map((p) => p.time_series?.[metricKey] ?? []);
  return sumPointsAcrossSeries(seriesList);
}

function sumPointsAcrossSeries(series: TimeSeriesPoint[][]): TimeSeriesPoint[] {
  const byDate = new Map<string, number>();
  for (const s of series) {
    for (const p of s ?? []) {
      byDate.set(p.date, (byDate.get(p.date) ?? 0) + p.value);
    }
  }
  return Array.from(byDate.entries())
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([date, value]) => ({ date, value }));
}

export function sumPerformancePagesTimeSeries(
  pages: PerformancePage[],
): PerformancePageTimeSeries {
  const keySet = new Set<string>();
  for (const p of pages) {
    const ts = p.time_series;
    if (!ts) {
      continue;
    }
    for (const k of Object.keys(ts)) {
      keySet.add(k);
    }
  }
  const out: PerformancePageTimeSeries = {};
  Array.from(keySet).forEach((key) => {
    const seriesList = pages.map((p) => p.time_series?.[key] ?? []);
    out[key] = sumPointsAcrossSeries(seriesList);
  });
  return out;
}

export function sumPerformancePagesComparisonTimeSeries(
  pages: PerformancePage[],
): PerformancePageTimeSeries | undefined {
  const hasAny = pages.some((p) => p.comparison_time_series);
  if (!hasAny) {
    return undefined;
  }
  const keySet = new Set<string>();
  for (const p of pages) {
    const ts = p.comparison_time_series;
    if (!ts) {
      continue;
    }
    for (const k of Object.keys(ts)) {
      keySet.add(k);
    }
  }
  const out: PerformancePageTimeSeries = {};
  Array.from(keySet).forEach((key) => {
    const seriesList = pages.map((p) => p.comparison_time_series?.[key] ?? []);
    out[key] = sumPointsAcrossSeries(seriesList);
  });
  return out;
}
